import React from 'react';

import type { ImageProps } from 'expo-image';

import { FullWidthAutoHeightImage } from 'components/ui/full-width-auto-height-image';

interface HeaderFlairProps {
  source: ImageProps['source'];
}

export const HeaderFlair = ({ source }: HeaderFlairProps) => (
  <FullWidthAutoHeightImage style={{ position: 'absolute', top: 0 }} source={source} />
);
